// extracted by mini-css-extract-plugin
module.exports = {"internalLink":"style-module_internalLink__1mPuoMx_-q_jhlfkjCyQSh","listInternalLink":"style-module_listInternalLink__39_TgdYWJtezPH5QXX6ycx"};